<template>
  <RsModal
    :value="showModal"
    :show-main-footer="false"
    scrollable
    @input="handleClose"
  >
    <template #modalTitle>
      <div class="d-flex align-items-center">
        <i class="fas fa-exclamation-circle rs-text-error mr-2" />
        <h4 class="mb-0">
          There were errors submitting your changes
        </h4>
      </div>
    </template>

    <p>
      The following requirements are missing:
    </p>

    <div
      v-for="(key, index) in Object.keys(errors)"
      :key="`${key}-${index}`"
      class="mb-2 error-leaf py-2 px-3 bg-light rounded"
    >
      <div>
        {{ key }}
      </div>
      <div
        v-for="(error, errorIndex) in errors[key]"
        :key="`${key}-${index}-error-${errorIndex}`"
        class="small font-weight-normal ml-3 rs-text-error d-flex align-items-center"
      >
        <i class="fas fa-exclamation-circle mr-2" />
        <div>{{ error }}</div>
      </div>
    </div>
  </RsModal>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { validationSummary } from '@/store/typed/typed-modules';
import { mapModuleActions, mapModuleGetters } from '@/shared/vuex-toolkit';

export default defineComponent({
  computed: {
    ...mapModuleGetters(validationSummary, ['showModal', 'errors']),
  },

  methods: {
    ...mapModuleActions(validationSummary, ['dismissSummary']),

    handleClose() {
      this.dismissSummary({});
    },
  },
});
</script>

<style lang="scss" scoped>
@import '@/styles/_variables.scss';

.error-leaf {
  border-left: solid 6px $error;
}
</style>
